export default __webpack_public_path__ + "static/media/suited-girl.b49cb822.png";